import { render, staticRenderFns } from "./register-header.vue?vue&type=template&id=10f6d54f&scoped=true"
import script from "./register-header.vue?vue&type=script&lang=js"
export * from "./register-header.vue?vue&type=script&lang=js"
import style0 from "./register-header.vue?vue&type=style&index=0&id=10f6d54f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6d54f",
  null
  
)

export default component.exports